import React from 'react';
import sanitizeHtml from 'sanitize-html';
import styled from 'styled-components';
import { encodeBracketEntities } from 'shared/helpers/encode-bracket-entities';

export default function SanitizedHtml({ className, html, omitBrs }) {
  /* eslint-disable i18next/no-literal-string */
  const allowedTags = ['b', 'i', 'em', 'strong', 'a', 'p', 'ul', 'ol', 'li'];
  const encodedHtml = encodeBracketEntities(html);
  if (!omitBrs) {
    allowedTags.push('br');
  }
  const sanitizedHtml = sanitizeHtml(encodedHtml, {
    allowedTags,
    allowedAttributes: {
      a: ['href', 'target'],
    },
    allowedSchemesByTag: {
      a: ['http', 'https', 'mailto', 'tel'],
    },
    transformTags: {
      a: sanitizeHtml.simpleTransform('a', { target: '_BLANK' }, true),
    },
  });

  return (
    <Wrapper
      className={className}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: sanitizedHtml,
      }}
    />
  );
}

const Wrapper = styled.div`
  strong {
    font-weight: bold;
  }
  em {
    font-style: italic;
  }

  ul,
  ol {
    margin-top: 0;
    padding-left: 0.5rem;
    list-style-position: inside;
  }
`;
